import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import SEO from '@/components/common/SEO';

const WelcomePage = () => {
  return (
    <MainLayout>
      <SEO
        title="Welcome"
        description="Learn why you need to register and login to use our AI services, including details about our free tier and upgrade options."
        keywords="welcome, register, login, free tier, upgrade, AI services"
      />
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <Card className="w-full">
          <CardHeader>
            <CardTitle className="text-center text-3xl font-bold">Welcome to mapleos!</CardTitle>

            <CardDescription className="text-center mt-2">
              Your journey to intelligent assistance starts here.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6 text-lg">
            <p>
              To fully experience the power of mapleos and utilize our advanced features,

              it's necessary to <span className="font-semibold">register and log in</span> to your account.
              This ensures a personalized and secure experience, allowing you to save your progress,
              access your chat history, and manage your AI agents and knowledge bases.
            </p>
            <p>
              We understand the importance of accessibility, which is why we offer a
              <span className="font-semibold"> free tier</span> by default. This allows you to explore
              many of our core functionalities without any initial commitment.
            </p>
            <p>
              For users who require more extensive capabilities, higher usage limits, or premium features,
              we offer various <span className="font-semibold">upgrade options</span>. You can easily
              purchase a plan that best suits your needs and unlock the full potential of mapleos.

            </p>
            <p className="text-center pt-4">
              Ready to get started?
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button asChild size="lg">
                <Link to="/auth">Register Now</Link>
              </Button>
              <Button asChild variant="outline" size="lg">
                <Link to="/auth">Login</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      </MainLayout>
  );
};

export default WelcomePage;